<template>
  <nuttrema-layout-west-slide width="25%" minWidth="35em">
    <west-slide-left-navigation slot="navigation-top">
      <router-link
         tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: getMetaAttr('navigation.cancel') }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->

    <nuttrema-layout-west-three-vertical>
      <div slot="top-center" class="top--center__title">
        <span>{{ $t(_get(meta, 'title', '')) }}</span>
      </div>
      <template slot="center">

        <nuttrema-menu-list theme="options-list">
          <template v-for="group in groups">
            <section>
              <p class="section-title">{{ $t('label.' + group.name) }}</p>
              <div class="section-items">
                <nuttrema-menu-list-item v-for="item in group.items" @click="goto(item.route, item.type)" :key="item.title">
                  <div class="nuttrema-menu-list-item__icon">
                    <nuttrema-iconica-sidebar-link
                      :icon="item.icon"
                      :theme="item.theme">
                    </nuttrema-iconica-sidebar-link>
                  </div>
                  <div class="nuttrema-menu-list-item__title">
                    <span>{{ $t('label.' + item.title) }}</span>
                  </div>
                  <div class="nuttrema-menu-list-item__action">
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </nuttrema-menu-list-item>
              </div>
            </section>
          </template>
        </nuttrema-menu-list>
      </template>
    </nuttrema-layout-west-three-vertical>

    <router-view></router-view>
  </nuttrema-layout-west-slide>
</template>

<script>
import * as ICONS from 'constants/icons';
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';

import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import NuttremaMenuList from 'components/ui/navigation/nuttrema-menu-list';
import NuttremaMenuListItem from 'components/ui/navigation/nuttrema-menu-list-item';

import EastSearchFilter from 'components/ui/search/east-search-filter';

export default {
  name: 'page-options-add-schedule-to-diet',
  mixins: [
    PageProps,
  ],
  components: {
    EastSearchFilter,
    NuttremaMenuList,
    NuttremaMenuListItem,
    NuttremaLayoutWestSlide,
    WestSlideLeftNavigation,
    NuttremaIconicaSidebarLink,
    NuttremaLayoutWestThreeVertical,
  },
  data() {
    return {
      groups: [
        {
          name: 'stuff_to_eat',
          items: [
            {
              title: 'food_product',
              type: 'food-products',
              icon: ICONS.FOOD_PRODUCT,
              theme: 'food-product',
              route: 'search-meal-contents',
            },
            {
              title: 'dish',
              type: 'dishes',
              icon: ICONS.DISH,
              theme: 'dish',
              route: 'search-meal-contents',
            },
            {
              title: 'drink',
              type: 'drinks',
              icon: ICONS.DRINK,
              theme: 'drink',
              route: 'search-meal-contents',
            },
          ],
        },
      ],
      filters: [],
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: this.cancelNavigation });
    },
    goto(route, type) {
      // console.log('clicked on route', route, type);
      this.$router.push({ name: route, params: { type } });
    },
    doSearch() {},
    doFilterByOrigin() {},
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/meals/details/content/page-options-add-content-to-meal.vue